import { createUseStyles } from 'react-jss'
import { colors } from '../colors'

export const style = {
  legendWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 24px'
  },
  border: {
    border: `1px solid ${colors.silver}`,
    borderRadius: 4
  },
  left: {
    flex: '1 1 auto',
    minWidth: 300,
    fontSize: 14,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  }
}

export const useStyles = createUseStyles(style)
